export default {"src":"/_next/static/media/photos-mini.ca7209b6.svg","height":12,"width":12,"blurWidth":0,"blurHeight":0};